import type { Move } from '../move/move';
import type { Ability } from './ability';
import type { EffortSlider } from './stat';
import type { PokemonType } from './type';
import type { POKEMON_ITEM_ID } from './item';
import type { EffectiveValue, Personality } from './damage';

export interface PokemonV2 {
  id: number;
  name_ja: string;
  hp: number;
  attack: number;
  defense: number;
  special_attack: number;
  special_defense: number;
  speed: number;
  picture_url: string;
  species_id: number;
  // ポケモンタイプIDの配列
  type_id_list: number[];
  ability_id_list: number[];
  move_id_list: number[];
  weight: number;
  usage_rate: number;
  // HOMEランクマ基準のSV登場フラグ
  is_sv?: boolean;
  // 剣盾登場フラグ
  is_swsh?: boolean;
  often_used_move: number[];
  often_used_tokusei: number[];
  often_used_terasu: number[];
  move_list?: Move[];
  ability_list?: Ability[];

  // 共通設定
  effective_value: EffectiveValue;
  effective_slider_step: EffortSlider;
  personality: Personality;
  selected_ability?: Ability;
  selected_ability_id?: number;
  selected_item_id?: POKEMON_ITEM_ID;
  // テラスタイプID
  terasu_type?: PokemonType;
  rankCorrection: rankCorrection;
  other_setting: calcOtherSetting;
  individualValue: individualValue;

  // 攻撃側専用
  selected_move?: Move;
  selected_move_id?: number;
  selected_hit_number?: number;
  shell_side_arm_special_personality?: Personality;
  shell_side_arm_special_effort?: EffortSlider;

  // 防御側専用
  selected_moves?: Move[];
  selected_move_ids?: number[];

}

export type Pokemon = PokemonV2;
export type PokemonOffenceInterface = PokemonV2;
export type PokemonDefenceInterface = PokemonV2;

export type PokemonStatusTag = 'status-ailment' | 'juuden' | 'burned' | 'poisoned' | 'paralyzed';

export interface calcOtherSetting {
  kodai_quark_stat?: 'attack' | 'special_attack';
  critical_hit_count?: number;
  custom_power?: number;
  // 現在HP（よわき等の条件入力。設定されていれば常時発動扱い）
  current_hp?: number;
  kodai_defense_stat?: 'none' | 'defense' | 'special_defense';
  double_power_condition?: boolean;
  // スロースタートの残りターン数（設定されていれば常時発動扱い）
  slow_start_turns?: number;
  statusTags?: PokemonStatusTag[];
}

export type rankCorrectionEnum = -6 | -5 | -4 | -3 | -2 | -1 | 0 | 1 | 2 | 3 | 4 | 5 | 6;

export interface rankCorrection {
  attack: rankCorrectionEnum;
  defense: rankCorrectionEnum;
  special_attack: rankCorrectionEnum;
  special_defense: rankCorrectionEnum;
  speed: rankCorrectionEnum;
}

export type individualValueEnum = 0 | 31;

export interface individualValue {
  hp: individualValueEnum;
  attack: individualValueEnum;
  defense: individualValueEnum;
  special_attack: individualValueEnum;
  special_defense: individualValueEnum;
  speed: individualValueEnum;
}

export const rankCorrectionEnumList: rankCorrectionEnum[] = [
  -6, -5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5, 6,
];

export const individualValueEnumList: individualValueEnum[] = [0, 31];

export interface PokemonOption {
  label: string;
  value: number;
  pokemon: PokemonV2;
}
